const COMPANY_POLICIES = {
    LANDING_PAGE: {
        RESOURCE_ID: 'companyPolicies',
    },
    HANDBOOKS_LIST: {
        RESOURCE_ID: 'handbookList',
    },
    HANDBOOKS_CUSTOM_POLICY_LIST: {
        RESOURCE_ID: 'customlistPolicies',
    },
    HANDBOOKS_CUSTOM_POLICY_TEMPLATES_LIST: {
        RESOURCE_ID: 'customlistPoliciesTemplates',
    },
    DOCUMENT_SIGNATURES: {
        RESOURCE_ID: 'documentSignatures',
    },
    ESIGNATURE_MANAGEMENT: {
        RESOURCE_ID: 'eSignatureManagement',
    },
    ESIGNATURE_REPORTING: {
        RESOURCE_ID: 'eSignatureReporting',
    },
};

export default COMPANY_POLICIES;
